export const HEIGHT = 48;
export const BANNER_NAME = 'MAIL_EXPIRY_REMINDER' as const;
